export var ResultType;
(function (ResultType) {
    ResultType["error"] = "error";
    ResultType["info"] = "info";
    ResultType["success"] = "success";
    ResultType["warning"] = "warning";
})(ResultType || (ResultType = {}));
